import { api } from './client';
import { endpoints } from './endpoints';

export function registerStudent(input) {
  return api.post(endpoints.auth.registerStudent, input);
}

export function registerCompany(input) {
  return api.post(endpoints.auth.registerCompany, input);
}

export function login(credentials) {
  return api.post(endpoints.auth.login, credentials);
}

export function logout(refreshToken) {
  return api.post(endpoints.auth.logout, { refresh_token: refreshToken });
}

export function getCurrentUser() {
  return api.get(endpoints.auth.me);
}

export function updateAccount(input) {
  return api.patch(endpoints.auth.me, input);
}

export function sendVerificationCode(email) {
  return api.post(endpoints.auth.sendVerification, { email });
}

export function verifyEmail(email, code) {
  return api.post(endpoints.auth.verifyEmail, { email, code });
}

export function forgotPassword(email) {
  return api.post(endpoints.auth.forgotPassword, { email });
}

/** Confirms a reset code without using it up. */
export function checkResetCode(email, code) {
  return api.post(endpoints.auth.checkResetCode, { email, code });
}

export function resetPassword(input) {
  return api.post(endpoints.auth.resetPassword, input);
}

export function changePassword(input) {
  return api.post(endpoints.auth.changePassword, input);
}

export function deleteAccount(input) {
  return api.post(endpoints.auth.deleteAccount, input);
}
